import React, { useState, useEffect } from 'react';

export default function InstallBanner() {
  const [prompt, setPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Already running as installed PWA
    if (window.matchMedia('(display-mode: standalone)').matches) return;

    const activate = (p) => { setPrompt(p); setVisible(true); };

    // Prompt may have fired before this component mounted
    if (window.__pwaInstallPrompt) {
      activate(window.__pwaInstallPrompt);
      return;
    }

    const onReady = () => { if (window.__pwaInstallPrompt) activate(window.__pwaInstallPrompt); };
    const onPrompt = (e) => { e.preventDefault(); window.__pwaInstallPrompt = e; activate(e); };

    window.addEventListener('pwaInstallReady', onReady);
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', () => setVisible(false));

    return () => {
      window.removeEventListener('pwaInstallReady', onReady);
      window.removeEventListener('beforeinstallprompt', onPrompt);
    };
  }, []);

  const handleInstall = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'accepted') { setVisible(false); window.__pwaInstallPrompt = null; }
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
      background: '#0f172a', color: '#fff', borderRadius: 14,
      padding: '12px 20px', display: 'flex', alignItems: 'center', gap: 14,
      boxShadow: '0 8px 32px rgba(0,0,0,0.35)', zIndex: 9999,
      border: '1px solid #334155', maxWidth: 420, width: 'calc(100vw - 48px)',
    }}>
      <img src="/logo192.png" alt="" style={{ width: 36, height: 36, borderRadius: 8, flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 700, fontSize: 13 }}>Install 4Sight Operations</div>
        <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 1 }}>Add to your desktop or home screen</div>
      </div>
      <button onClick={handleInstall} style={{
        background: '#0d9488', color: '#fff', border: 'none', borderRadius: 8,
        padding: '7px 16px', fontWeight: 700, fontSize: 13, cursor: 'pointer', flexShrink: 0,
      }}>
        Install
      </button>
      <button onClick={() => setVisible(false)} style={{
        background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: 20, padding: 0, flexShrink: 0,
      }}>×</button>
    </div>
  );
}
